import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { PayloadAction } from '@reduxjs/toolkit';
import { UserId } from 'features/users/types';
import { logger } from 'utils/logger';

export function* muteRemoteVideoSaga(action: PayloadAction<UserId>) {
  logger
    .remote({ action: true, tier: 1 })
    .log(`Mute camera remotely for the user id=${action.payload}`);

  yield call(SignalingSocket.send, {
    event: 'muteRemoteVideo',
    data: {
      id: action.payload,
    },
  });
}
